import { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useMediaQuery } from "react-responsive";

import { selectEssSwitch } from "shared/slice/essSwitchSlice";
import { selectTgsSwitch } from "shared/slice/tgsSwitchSlice";
import { selectTesSwitch } from "shared/slice/tesSwitchSlice";
import {
  handleLocationSelectBySwitch,
  handleMachineSelectBySwitch,
  handleResetSelectedOne,
  handleSelectAllBySwitch,
  handleSpecificLocationSelectBySwitch,
  selectMCBySwitch,
} from "shared/slice/masterControlBySwitchSelectSlice";

import {
  handleMachineSelectByLocation,
  handleLocationSelectByLocation,
  handleSelectAllByLocation,
  selectMCByLocation,
  handleSpecificLocationSelectByLocation,
  handleResetSelectedOneByLocation,
} from "shared/slice/masterControlSelectByLocationSlice";

import styled, { css } from "styled-components";

import SelectMachineItems from "./SelectMachineItems";
import {
  flexBoxCenter,
  justifyContentSpaceBetween,
  layerA180Deg,
  layerADark,
  layerADisabled180Deg,
  layerBDark,
  layerBDisabled,
} from "shared/styles/commonStyles";
import selectBoxResetHandler from "shared/helpers/ess-tgs-tes-mc/selectBoxResetHandler";

const SelectLocations = ({
  size,
  name,
  disabled,
  scope,
  swtName,
  specificLocation,
}) => {
  const isMobile = useMediaQuery({ query: "(max-width:600px)" });






  const { essSwitch, tgsSwitch, tesSwitch } = useSelector(
    swtName === "ess"
      ? selectEssSwitch
      : swtName === "tgs"
        ? selectTgsSwitch
        : selectTesSwitch
  );
  const switchStatusE =
    swtName === "ess" ? essSwitch : swtName === "tgs" ? tgsSwitch : tesSwitch;

  let switchStatus =
    swtName === "ess" ? essSwitch : swtName === "tgs" ? tgsSwitch : tesSwitch;

  if (scope !== 'switch') {
    if (switchStatus[scope]?.isSpecificLocation) {
      switchStatus = switchStatus[scope].subLocations
    } else if (switchStatus && switchStatus[scope]) {
      switchStatus = { [scope]: switchStatus[scope] };
    } else if (switchStatus) {
      const parentLocation = Object.keys(switchStatus).find((ele) => {
        if (switchStatus[ele].isSpecificLocation) {
          return Object.keys(switchStatus[ele].subLocations).includes(scope)
        }
      })

      if (parentLocation) {
        switchStatus = { [scope]: switchStatus[parentLocation].subLocations[scope] }
      }
    }
  }























  const mCBySwitch = useSelector(
    scope === "switch" ? selectMCBySwitch : selectMCByLocation
  );

  const { selectedOne } = mCBySwitch[name];


  const [displaySelectBox, setDisplaySelectBox] = useState(false);
  const dispatch = useDispatch();
  const arrowSrc = disabled
    ? "/images/masterCtr-select-btn-disabled.svg"
    : displaySelectBox
      ? "/images/masterCtr-select-btn.svg"
      : "/images/masterCtr-select-btn.svg";


  const presetSelectBoxHandler = (
    allSelectFC,
    selectLocationFC,
    selectSpecificLocationFC,
    selectMachineFC,
    handleResetSelectedOne
  ) => {

    dispatch(allSelectFC({ controller: name, status: false }));

    dispatch(handleResetSelectedOne());




















    let switchData;



    switchData = switchStatus;


    const { locationList, specificLocationList, machineList } =
      selectBoxResetHandler(switchData);





    dispatch(selectLocationFC({ arr: locationList, controller: name }));


    dispatch(
      selectSpecificLocationFC({
        arr: specificLocationList,
        controller: name,
      })
    );


    dispatch(selectMachineFC({ arr: machineList, controller: name }));
  };

  useEffect(() => {
    if (displaySelectBox) {
      if (scope === "switch") {
        presetSelectBoxHandler(
          handleSelectAllBySwitch,
          handleLocationSelectBySwitch,
          handleSpecificLocationSelectBySwitch,
          handleMachineSelectBySwitch,
          handleResetSelectedOne
        );
      } else {

        presetSelectBoxHandler(
          handleSelectAllByLocation,
          handleLocationSelectByLocation,
          handleSpecificLocationSelectByLocation,
          handleMachineSelectByLocation,
          handleResetSelectedOneByLocation
        );
      }
    }
  }, [displaySelectBox]);

  return (
    <>
      {isMobile ? (
        <MobileWrapper
          displaySelectBox={displaySelectBox}
          isSmall={scope !== "switch"}
        >
          <SelectedOneAndArrowButtonWrapper
            isMobile={isMobile}
            isSmall={scope !== "switch"}
          >
            <SelectTop
              size={size}
              disabled={disabled}
              isMobile={isMobile}
              isSmall={scope !== "switch"}
            >
              {selectedOne
                ? selectedOne
                : scope === "switch"
                  ? "select locations"
                  : specificLocation
                    ? "select specific location"
                    : "select switches"}
            </SelectTop>

            <SelectArrowButton
              isSmall={scope !== "switch"}
              isMobile={isMobile}
              disabled={disabled}
              src={arrowSrc}
              onClick={() => disabled || setDisplaySelectBox(!displaySelectBox)}
            />
          </SelectedOneAndArrowButtonWrapper>

          {displaySelectBox && (
            <SelectMachineItems
              isMobile={isMobile}
              handleClose={() => setDisplaySelectBox(!displaySelectBox)}
              data={switchStatus}
              dataE={switchStatusE}
              swtName={swtName}
              name={name}
              scope={scope}
              specificLocation={specificLocation}
            />
          )}
        </MobileWrapper>
      ) : (
        <>

          {size !== 3 ? (
            <Wrapper
              disabled={disabled}
              displaySelectBox={displaySelectBox}
              size={size}
              isMobile={isMobile}
            >
              <SelectInnerWrapper
                disabled={disabled}
                displaySelectBox={displaySelectBox}
                size={size}
                isMobile={isMobile}
              >
                <SelectedOneAndArrowButtonWrapper
                  size={size}
                  isMobile={isMobile}
                >
                  <SelectTop
                    size={size}
                    disabled={disabled}
                    isMobile={isMobile}
                    isTop={selectedOne ? true : false}
                  >
                    {selectedOne
                      ? selectedOne
                      : scope === "switch"
                        ? "select locations"
                        : specificLocation
                          ? "select switches"
                          : "select specific location"}
                  </SelectTop>
                  <SelectArrowButton
                    isMobile={isMobile}
                    disabled={disabled}
                    src={arrowSrc}
                    onClick={() =>
                      disabled || setDisplaySelectBox(!displaySelectBox)
                    }
                  />
                </SelectedOneAndArrowButtonWrapper>
                {displaySelectBox && (
                  <SelectMachineItems
                    isMobile={isMobile}
                    handleClose={() => setDisplaySelectBox(!displaySelectBox)}
                    data={switchStatus}
                    dataE={switchStatusE}
                    swtName={swtName}
                    name={name}
                    scope={scope}
                  />
                )}
              </SelectInnerWrapper>
            </Wrapper>
          ) : (
            <Wrapper2 disabled={disabled} displaySelectBox={displaySelectBox}>
              <SelectInnerWrapper2
                disabled={disabled}
                displaySelectBox={displaySelectBox}
              >
                <SelectedOneAndArrowButtonWrapper2
                  size={size}
                  displaySelectBox={displaySelectBox}
                >
                  <SelectArrowButton
                    size={size}
                    disabled={disabled}
                    src={"/images/masterCtr-select-btn.svg"}
                    onClick={() =>
                      disabled || setDisplaySelectBox(!displaySelectBox)
                    }
                  />
                  <SelectTop2
                    isSelected={selectedOne}
                    imgSrc="/images/shutOff-select-location.svg"
                  >
                    <SelectedOne2 isAll={size === 3 && selectedOne === "all"}>
                      {selectedOne ? selectedOne : "select locations"}
                    </SelectedOne2>
                  </SelectTop2>
                </SelectedOneAndArrowButtonWrapper2>
              </SelectInnerWrapper2>

              {displaySelectBox && (
                <Wrapper
                  disabled={disabled}
                  displaySelectBox={displaySelectBox}
                  size={size}
                  isMobile={isMobile}
                  name={name}
                >
                  <SelectInnerWrapper
                    disabled={disabled}
                    displaySelectBox={displaySelectBox}
                    size={size}
                    isMobile={isMobile}
                  >
                    <SelectedOneAndArrowButtonWrapper
                      size={size}
                      isMobile={isMobile}
                    >
                      <SelectTop
                        size={size}
                        disabled={disabled}
                        isMobile={isMobile}
                      >
                        {selectedOne
                          ? selectedOne
                          : scope === "switch"
                            ? "select locations"
                            : specificLocation
                              ? "select switches"
                              : "select specific location"}
                      </SelectTop>
                      <SelectArrowButton
                        isMobile={isMobile}
                        disabled={disabled}
                        src={arrowSrc}
                        onClick={() =>
                          disabled || setDisplaySelectBox(!displaySelectBox)
                        }
                      />
                    </SelectedOneAndArrowButtonWrapper>
                    {displaySelectBox && (
                      <SelectMachineItems
                        isMobile={isMobile}
                        handleClose={() =>
                          setDisplaySelectBox(!displaySelectBox)
                        }
                        data={switchStatus}
                        dataE={switchStatusE}
                        swtName={swtName}
                        name={name}
                        scope={scope}
                        specificLocation={specificLocation}
                      />
                    )}
                  </SelectInnerWrapper>
                </Wrapper>
              )}
            </Wrapper2>
          )}
        </>
      )}
    </>
  );
};

export default SelectLocations;

const MobileWrapper = styled.div`
  ${(p) =>
    p.isSmall
      ? css`
          width: 299px;
          height: 68px;
          border-radius: 34px;
          ${layerA180Deg};
          ${flexBoxCenter};

          ${(p) =>
          p.displaySelectBox &&
          css`
              height: auto;
              flex-direction: column;
              justify-content: space-between;
              padding: 5px 0;
              border-radius: 32px;
            `};
        `
      : css`
          width: 310px;
          height: 68px;
          border-radius: 34px;
          ${layerA180Deg};
          ${flexBoxCenter};

          ${(p) =>
          p.displaySelectBox &&
          css`
              height: auto;
              flex-direction: column;
              justify-content: space-between;
              padding: 5px 0;
            `}
        `};
`;


const Wrapper = styled.div`
  width: 100%;
  height: 40px;
  border-radius: 9999px;

  ${flexBoxCenter}
  position: relative;

  ${(p) =>
    p.disabled &&
    css`
      opacity: 0.6;
    `}

  ${(p) =>
    p.size === 3 &&
    css`
      width: 77px;
      height: 43px;
    `}


    ${(p) =>
    p.name === "shutOff" &&
    css`
      position: absolute;
      top: 0px;
      right: 56px;
    `}
`;

const SelectInnerWrapper = styled.div`
  width: 100%;
  height: 40px;
  border-radius: 9999px;
  ${flexBoxCenter}
  background: var(--bg-input);
  border: 0.8px solid var(--border-input);
  box-shadow: inset 0px 2px 8px rgba(0, 0, 0, 0.8);

  padding: 0 12px 0 16.8px;

  ${(p) =>
    p.displaySelectBox &&
    css`
      height: auto;
      flex-direction: column;
      ${layerA180Deg};
      ${justifyContentSpaceBetween};
      box-shadow: none;

      position: absolute;
      top: 1px;
      left: 0;
      z-index: 100;
      border-radius: ${p.size === 2 ? `12px` : `18px`};
      padding: 3px 4px 4px 2.5px;
    `}

    ${(p) =>
    p.disabled &&
    css`
      ${layerADisabled180Deg}
    `}
`;

const SelectedOneAndArrowButtonWrapper = styled.div`
  width: 100%;
  ${justifyContentSpaceBetween}

  ${(p) =>
    p.isMobile
      ? css`
          ${(p) =>
          p.isSmall
            ? css`
                  height: auto;
                  padding: 0 10px 0 5px;
                `
            : css`
                  height: auto;
                  padding: 0 15px 0 6px;
                `}
        `
      : css`
          ${p.size === 1 &&
        css`
            padding: 0 4px 0 1px;
          `}
        `};
`;

const SelectArrowButton = styled.img`
  margin-right: 2rem;
  margin-top: 1rem;
  cursor: pointer;
  ${(p) =>
    p.disabled &&
    css`
      cursor: not-allowed;
    `}

  ${(p) =>
    p.size === 3 &&
    css`
      position: absolute;
      top: 6px;
      right: 2px;
    `}

    ${(p) =>
    p.isMobile &&
    css`
      width: 32px;
      height: 29px;
      margin-top: 4px;
    `}
`;

const SelectTop = styled.div`
  flex: 1;
  min-width: 0;
  display: flex;
  align-items: center;

  font-family: 'Inter', sans-serif;
  font-weight: 500;
  font-size: 12px;
  color: var(--switch-text-secondary);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;

  ${(p) =>
    p.disabled &&
    css`
      color: var(--switch-text-faint);
    `}

    ${(p) =>
    p.isMobile &&
    css`
      width: 244px;
      height: 58px;
      border-radius: 29px;
      ${layerADark};
      padding-left: 20px;
      font-size: 12px;
      letter-spacing: 1.2px;
    `}
`;


const Wrapper2 = styled.div`
  width: 77px;
  height: 43px;
  border-radius: 5px;

  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  position: relative;

  ${(p) =>
    p.disabled &&
    css`
      ${layerBDisabled}
    `}

  ${(p) =>
    p.displaySelectBox
      ? css``
      : css`
          ${layerBDark}
        `};
`;

const SelectInnerWrapper2 = styled.div`
  width: 75px;
  height: 41px;
  border-radius: 4px;

  ${justifyContentSpaceBetween}



  ${(p) =>
    p.disabled &&
    css`
      ${layerADisabled180Deg}
    `}

    ${(p) =>
    p.displaySelectBox
      ? css``
      : css`
          ${layerA180Deg}
        `};
`;

const SelectedOneAndArrowButtonWrapper2 = styled.div`
  width: 100%;
  height: 100%;

  display: flex;
  justify-content: center;
  align-items: flex-end;

  padding: 0 0 2px 0;
  position: relative;

  ${(p) =>
    p.displaySelectBox &&
    css`
      visibility: hidden;
    `};
`;

const SelectTop2 = styled.div`
  width: 69px;
  height: 23px;
  background: url(${(p) => p.imgSrc}) no-repeat;

  ${flexBoxCenter}

  ${(p) =>
    p.isSelected &&
    css`
      padding-top: 10px;
    `}
`;

const SelectedOne2 = styled.span`
  font-size: 8px;

  ${(p) =>
    p.isAll &&
    css`
      width: 100%;
      padding-left: 2px;
    `}
`;
